























































































import { Vue, Component } from 'vue-property-decorator';
import axios from 'axios';

import Container from '../../Registration/v2/Container.vue';
import RegistrationCard from '../../Registration/v2/Card.vue';
import CardHeader from '../../Registration/v2/Header.vue';
import { vxm } from '@/store.vuex';
import { ForgotPasswordRequest } from '@/models/userdata/forgotpasswordreqeust';

@Component({
  components: {
    Container,
    RegistrationCard,
    CardHeader,
  },
})
export default class ForgotPasswordForm extends Vue {
  private request: ForgotPasswordRequest = new ForgotPasswordRequest();
  private showSumbitButton: boolean = true;
  private emailRegex: RegExp = vxm.utility.emailRegex;
  private isEmailPresent: boolean = false;
  private isMobileScreen: boolean = false;

  private errors = {
    userEmail: '',
  };
  $wlToastr: any;

  async onSubmit() {
    if (this.validateData()) {
      const resp = await axios.post(
        '/wl-profile-svc/api/user-profile/v2/forgotPassword',
        this.request,
        {
          headers: {
            Authorization: 'Bearer ' + vxm.users.getToken,
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
        },
      );
      if (resp.data.success) {
        this.$wlToastr(
          'success',
          this.$t('otp-login.toast.codesentmessage'),
          this.$t('otp-login.toast.title'),
        );
        vxm.users.setRouterAfterOTPForm('ChangePasswordV2');
        vxm.users.setForceChangePwd(true);
        this.$router.push({
          name: 'OTPLogin',
          params: { username: this.request.userEmail },
        });
      } else {
        this.showSumbitButton = !(
          resp.data.errorMessage ===
          this.$t('forgotpassword.socialmedia.errormessage')
        );

        this.errors.userEmail = resp.data.errorMessage;
      }
    }
  }

  validateData(): boolean {
    this.errors.userEmail = '';
    if (!this.emailRegex.test(this.request.userEmail)) {
      this.errors.userEmail = 'forgotpassword.enter.valid.email';
    } else if (this.request.userEmail === '') {
      this.errors.userEmail = 'forgotpassword.email.required';
    }

    return '' === this.errors.userEmail;
  }

  mounted() {
    this.isMobileScreen = vxm.utility.isMobileDevice;
    this.request.userEmail = this.$cookies.get('userName');
    this.isEmailPresent =
      null != this.request.userEmail && '' !== this.request.userEmail;
    this.request.companyCode = vxm.jobs.BrandingInfo.companycode;
  }

  get showSupportPhoneNumber(): boolean {
    return vxm.configs.getGlobalConfigValue('SUPPORT_PHONE_NUMBER') ? true : false;
  }

  get supportEmail(): string {
    return vxm.configs.getGlobalConfigValue('SUPPORT_EMAIL') || vxm.utility.supportEmail;
  }

  get supportPhoneNumber(): string {
    return (
      vxm.configs.getGlobalConfigValue('SUPPORT_PHONE_NUMBER') || vxm.utility.supportPhoneNo
    );
  }
}
